import { useCallback, useRef, useState } from 'react';

import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { getActiveChannel } from '@/store/slices/user/selectors';
import { loadRecordings, loadUploadedVideos } from '@/store/slices/content';
import toastTrigger from '@ui/toast/toast-trigger';

const useLoadVideos = () => {
  const activeChannel = useAppSelector(getActiveChannel);
  const dispatch = useAppDispatch();
  const fetching = useRef(false);
  const [loading, setLoading] = useState(false);

  const fetchVideos = useCallback(async () => {
    if (fetching.current || !activeChannel) {
      return;
    }

    fetching.current = true;
    setLoading(true);

    try {
      await Promise.all([dispatch(loadRecordings(activeChannel)), dispatch(loadUploadedVideos(activeChannel))]);
    } catch (error) {
      console.error('Error fetching videos:', error);
      toastTrigger(<div className="S1">Error loading videos</div>, { type: 'error' });
    } finally {
      fetching.current = false;
      setLoading(false);
    }
  }, [activeChannel, dispatch]);

  return { fetchVideos, loading };
};

export default useLoadVideos;
